/**************************************************************************************************/
/** @import Node Packages                                                                        **/
/**************************************************************************************************/
import { defineComponent } from 'vue'

/**************************************************************************************************/
/** @import Helpers/Utils                                                                        **/
/**************************************************************************************************/
import { PrintHelper } from '@/Helpers/Utils/PrintHelper'

/**************************************************************************************************/
/** @import Mixins                                                                               **/
/**************************************************************************************************/
import MixinComponent from '@/Mixins/MixinComponent'
import MixinResponsive from '@/Mixins/MixinResponsive'

/**************************************************************************************************/
/** @internal Const @name MenuBar                                                                **/
/**************************************************************************************************/
const MenuBar = defineComponent(
{
	/*************************************************/
	/** @Properties                                 **/
	/*************************************************/
	name: 'MenuBar', mixins: [MixinComponent, MixinResponsive],

	props:
	{
		show: Boolean
	},

	/*************************************************/
	/** @Data                                       **/
	/*************************************************/
	data()
	{
		return {
			items: [] as Array<any>,
			states:
			{
				canClickItem: true,
				isMobile: false,
				selected: undefined as any
			}
		}
	},

	/*************************************************/
	/** @Methods                                    **/
	/*************************************************/
	methods:
	{
		GetItemByKey(key: string) : any
		{
			return this.items.find((x: any) => x.key === key)
		},

		GetSelectedClass(item: any) : object
		{
			if (Array.isArray(item.items))
			{
				for (const sItem of item.items)
				if (sItem.key === this.states.selected)
				return { ['category-selected']: true }
			}
			return { selected: item.key === this.states.selected }
		},

		OnMBItemClick(item: any) : any
		{
			// Si 'canClickItem' es 'false', prevenir ejecución del evento.
			if (!this.states.canClickItem) return

			// Ejecución normal del evento 'onMBItemClick'.
			PrintHelper.warning('[MenuBar]:onMBItemClick() event triggered')
			if (Array.isArray(item.items))
			{
				// Ocultar la misma categoria si esta abierta.
				if (item.categoryOpened) return item.categoryOpened = false

				// Ocultar todas las categorias.
				for (const _item of this.items) if ('categoryOpened' in _item) _item.categoryOpened = false

				// Mostrar la categoria seleccionada.
				item.categoryOpened = true
			}
			else
			{
				// Cerrar cualquier opción anterior que se encuentre abierta.
				for (const _item of this.items) if ('categoryOpened' in _item) _item.categoryOpened = false

				if (this.states.selected === item.key) return
				this.Set<MenuBarRef['states']>({ selected: item.key })
				this.$emit('onMBItemClick', item.key)
			}
		},

		OnMBSubItemClick(event: MouseEvent, item: any, sItem: any) : void
		{
			PrintHelper.warning('[MenuBar]:onMBSubItemClick() event triggered')
			event.stopPropagation()
			item.categoryOpened = false
			this.Set<MenuBarRef['states']>({ selected: sItem.key })
			this.$emit('onMBItemClick', sItem.key)
		},

		SetItems(items: Array<any>) : void
		{
			this.items = items
		}
	}
})

/**************************************************************************************************/
/** @export Component @name MenuBar                                                              **/
/**************************************************************************************************/
export default MenuBar

/**************************************************************************************************/
/** @export Type @name MenuBarRef                                                                **/
/**************************************************************************************************/
export type MenuBarRef = InstanceType<typeof MenuBar>